import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@ddt-web/common';
import { ConfigModule } from '@ddt-web/config';
import { DataServiceModule } from '@ddt-web/data-service';
import { GenericPipesModule } from '@ddt-web/generic-utils';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { NewChartComponent } from './components/chart/chart.component';
import { MultiChartComponent } from './components/chart/multi-chart.component';
import { ChartSkeletonComponent } from './components/chart/skeletons/chart-skeleton.component';

@NgModule({
	imports: [CommonModule, SharedModule, GenericPipesModule, NgxSkeletonLoaderModule, DataServiceModule, ConfigModule],
	declarations: [NewChartComponent, ChartSkeletonComponent, MultiChartComponent],
	exports: [NewChartComponent, ChartSkeletonComponent, MultiChartComponent]
})
export class NewChartModule { }
